import { ISO639_1_LANGUAGES, type ISO639_1_Language } from "@shared/types";

const convertMap: Record<string, ISO639_1_Language> = {
	"zh-CN": "zh_cn",
	"zh-TW": "zh_tw",
	"pt-PT": "pt_pt",
	"pt-BR": "pt_br",
	"es-419": "es_419",
};

export function useDefaultUserLanguage() {
	const browserLocale = navigator.language;
	if (!browserLocale || typeof browserLocale !== "string") return "en";
	if (convertMap[browserLocale]) {
		return convertMap[browserLocale];
	}
	// Split by "-" or "_" (some locales use underscore)
	const isoCode = browserLocale.split(/[-_]/)[0].toLowerCase();

	return ISO639_1_LANGUAGES.includes(isoCode as ISO639_1_Language)
		? (isoCode as ISO639_1_Language)
		: "en";
}
